export default __webpack_public_path__ + "static/media/Badminton Hall, PKL6.8d7b10cd.jpg";